module.exports = __webpack_public_path__ + "static/iphone-mockup-b321fceeeff71a03f0fd087048dbc84b.png";